import React from "react";

const RefreshCircle = ({ size = 14, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <path
      d="M7.00008 12.8337C10.2217 12.8337 12.8334 10.222 12.8334 7.00033C12.8334 3.77866 10.2217 1.16699 7.00008 1.16699C3.77842 1.16699 1.16675 3.77866 1.16675 7.00033C1.16675 10.222 3.77842 12.8337 7.00008 12.8337Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.67261 8.46397C4.77761 8.63897 4.90594 8.80232 5.05177 8.94815C6.1251 10.0215 7.86927 10.0215 8.94843 8.94815C9.38593 8.51065 9.63677 7.95646 9.71844 7.39062"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.28174 6.6096C4.3634 6.03793 4.61424 5.48957 5.05174 5.05207C6.12508 3.97874 7.86924 3.97874 8.9484 5.05207C9.10007 5.20374 9.22257 5.36708 9.32757 5.53625"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.56177 10.0214V8.46387H6.11926"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.43835 3.97852V5.53601H7.88086"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default RefreshCircle;
